import { orderBy } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ActionComponent from '../../../../../components/ActionComponent'
import { getMapStateToProps, getPropTypes } from '../../../../../utils/StoreUtils'
import { substringText } from '../../../../../utils/StringUtil'
import DtoBoreholeLithologyItem from '../dto/DtoBoreholeLithologyItem'
import { CardTable } from 'components/datatable/NewTable'

const headers = ['depth', 'comment']

const storeProps = {
    sandreCodes: false,
}

class BoreholeLithologyDashboard extends ActionComponent {
    getFirstPart = (lithology) => {
        const firstPart = lithology.find(l => l.order === 0)
        if (firstPart) {
            return firstPart.comment.split('\n').map(txt => <h6>{txt}</h6>)
        }
        return null
    }

    getDepth = (lithology, index, lithologies) => {
        if (index === 0) {
            return `0-${lithology.thickness}${i18n.metersSymbol}`
        }
        return `${lithologies[index - 1].thickness}-${lithology.thickness}${i18n.metersSymbol}`
    }

    getSummary = (lithology) => {
        if (lithology && lithology.length) {
            const orderedLithology = orderBy(lithology, 'thickness')
            const data = orderedLithology.map((l, i) => new DtoBoreholeLithologyItem(Object.assign({}, l, {
                depth: this.getDepth(l, i, orderedLithology),
                comment: substringText(l.comment, 125),
            })))
            return data.length ? (
                <CardTable
                    rows={data}
                    headers={headers}
                    title={ i18n.lithology }
                    hideNbElements
                />
            ) : null
        }
        return null
    }

    render() {
        return this.getSummary(this.props.station.link_lithology)
    }
}

BoreholeLithologyDashboard.propTypes = getPropTypes(storeProps, {
    station: PropTypes.object,
})

const mapStateToProps = () => getMapStateToProps(storeProps)

export default connect(mapStateToProps)(BoreholeLithologyDashboard)
